<article class="table-header">
    <button *ngIf="!exploreMode" class="" mat-raised-button color="primary" (click)="addRow()">
        {{'THIRDPARTY.CREATE_FORM.BUTTON.ADD_ROW' | translate}}
    </button>
</article>

<!-- Desk -->
 <div class="table">
    <table mat-table [dataSource]="dataSource" class="d-none d-lg-table mb-3">
        <ng-container [matColumnDef]="'column_' + col.id" *ngFor="let col of columnsSchema">
            <th mat-header-cell *matHeaderCellDef>
                <span *ngIf="col.columnTypeId != -1">{{ col.title }}</span>
            </th>
            <td class="center" [ngClass]="{'breakWord': col.columnOrder == 1}" mat-cell *matCellDef="let element; let iElement = index">
                <div [ngSwitch]="col.columnTypeId" *ngIf="!element.isEdit">
    
                    <div class="btn-edit" *ngSwitchCase="-1"><!--isEdit-->
                        <button *ngIf="!exploreMode" mat-icon-button (click)="saveRow(element)" color="primary">
                            <mat-icon matTooltip="{{'THIRDPARTY.CREATE_FORM.BUTTON.EDIT' | translate}}"
                                class="">edit</mat-icon>
                        </button>
                        <button *ngIf="!exploreMode" mat-icon-button class="" (click)="removeRow(iElement)">
                            <mat-icon matTooltip="{{'THIRDPARTY.CREATE_FORM.BUTTON.DELETE' | translate}}"
                                class="close-btn">close</mat-icon>
                        </button>
                    </div>
                    <span *ngSwitchCase="columnTypesEnum.RecordTypeSelect">
                        {{getRecordField(element[col.columnOrder], col.recordField)}}
                    </span>
                    <span [ngClass]="{'breakWord': col.columnOrder == 1}" *ngSwitchDefault>
                        {{ element[col.columnOrder] }}
                    </span>
                </div>
                <div class="horizontalScroll" [ngSwitch]="col.columnTypeId" *ngIf="element.isEdit && !exploreMode">
    
                    <div class="btn-edit" *ngSwitchCase="-1"> <!--isEdit-->
                        <button mat-icon-button (click)="saveRow(element)" [disabled]="cantSaveRow(element)">
                            <mat-icon matTooltip="{{'THIRDPARTY.CREATE_FORM.BUTTON.SAVE' | translate}}"
                                class="check-btn">check</mat-icon>
                        </button>
    
                        <button mat-icon-button class="" (click)="removeRow(iElement)">
                            <mat-icon matTooltip="{{'THIRDPARTY.CREATE_FORM.BUTTON.DELETE' | translate}}"
                                class="close-btn">close</mat-icon>
                        </button>
                    </div>
    
                    <!-- Type Text -->
                    <mat-form-field class="form-input" *ngSwitchCase="columnTypesEnum.Text" appearance="fill">
                        <input [type]="text" matInput [(ngModel)]="element[col.columnOrder]" placeholder=""/>
                    </mat-form-field>
                    <!-- Type Numeric -->
                    <mat-form-field class="form-input num" *ngSwitchCase="columnTypesEnum.Numeric" appearance="fill">
                        <input [type]="number" matInput [(ngModel)]="element[col.columnOrder]" placeholder="0"
                            (keypress)="numberOnly($event)"/>
                    </mat-form-field>
                    <!-- Type Calculated -->
                    <mat-form-field class="form-input num" *ngSwitchCase="columnTypesEnum.Calculated" appearance="fill">
                        <input [type]="number" matInput [ngModel]="getCalculated(element, col)" readonly />
                    </mat-form-field>
                    <!-- Type List -->
                    <mat-form-field class="form-input select" *ngSwitchCase="columnTypesEnum.List" appearance="fill">
                        <mat-select [(ngModel)]="element[col.columnOrder]">
                            <mat-option *ngFor="let answer of col.possibleAnswers" [value]="answer">
                                {{answer}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <!-- Type RecordTypeSelect -->
                    <mat-form-field class="form-input select" *ngSwitchCase="columnTypesEnum.RecordTypeSelect" appearance="fill">
                        <mat-select [(ngModel)]="element[col.columnOrder]">
    
                            <ng-container *ngFor="let answer of getrecordTypeDataFiltered(col.recordTypeId, col.recordField); count as c">
                                <mat-option *ngIf="c > 0" [value]="answer">
                                    <span>{{getRecordField(answer, col.recordField)}}</span>
                                </mat-option>
                                
                                <mat-option *ngIf="c < 1">
                                    <span>{{'THIRDPARTY.RECORD_TYPE_QUESTION.NO_OPTIONS_AVALAIBLE' | translate}}</span>
                                </mat-option>
                            </ng-container>
                            
                        </mat-select>
                    </mat-form-field>
                    <!-- Type RecordTypeAutocomplete -->
                    <mat-form-field class="form-input select" *ngSwitchCase="columnTypesEnum.RecordTypeAutocomplete" appearance="fill">
                        <input [type]="text" matInput [ngModel]="getAutoCompleteValue(element, col)" readonly />
                    </mat-form-field>
                </div>
            </td>
            <td class="center" mat-footer-cell *matFooterCellDef>
                <span *ngIf="col.columnOrder == 1">Total:</span>
                <span  *ngIf="col.columnTypeId != -1 && col.useVerticalTotalizer">{{ calculateTotal(col) }}</span>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="rowHeader"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <tr mat-footer-row *matFooterRowDef="displayedColumns" class="rowFooter"></tr>
    </table>
 </div>

<!-- //Desk -->

<!-- Mobile -->
<div class="d-block d-lg-none mt-3">
    <!--Records Cards-->
    <mat-card *ngFor="let item of dataSource.data; let iElement = index" class="mb-3">
        <mat-card-content>
            <div class="d-flex flex-column justify-content-start">
                <ng-container *ngFor="let col of columnsSchema">
                    <div *ngIf="col.columnTypeId != -1" class="d-flex flex-column justify-content-start mb-3">

                        <span class="mb-2"><strong>{{ col.title }}</strong></span>

                        <ng-container [ngSwitch]="col.columnTypeId" *ngIf="!item.isEdit">
                            <span *ngSwitchCase="columnTypesEnum.RecordTypeSelect">
                                {{getRecordField(item[col.columnOrder], col.recordField)}}
                            </span>
                            <span *ngSwitchDefault>
                                {{ item[col.columnOrder] }}
                            </span>
                        </ng-container>

                        <ng-container [ngSwitch]="col.columnTypeId" *ngIf="item.isEdit">
                            <!-- Type Text -->
                            <mat-form-field class="form-input" *ngSwitchCase="columnTypesEnum.Text" appearance="fill">
                                <input [type]="text" matInput [(ngModel)]="item[col.columnOrder]" placeholder=""/>
                            </mat-form-field>

                            <!-- Type Numeric -->
                            <mat-form-field class="form-input num" *ngSwitchCase="columnTypesEnum.Numeric" appearance="fill">
                                <input [type]="number" matInput [(ngModel)]="item[col.columnOrder]" placeholder="0"
                                    (keypress)="numberOnly($event)"/>
                            </mat-form-field>

                            <!-- Type Calculated -->
                            <mat-form-field class="form-input num" *ngSwitchCase="columnTypesEnum.Calculated" appearance="fill">
                                <input [type]="number" matInput [ngModel]="getCalculated(item, col)" readonly />
                            </mat-form-field>
                            
                            <!-- Type List -->
                            <mat-form-field class="form-input select" *ngSwitchCase="columnTypesEnum.List" appearance="fill">
                                <mat-select [(ngModel)]="item[col.columnOrder]">
                                    <mat-option *ngFor="let answer of col.possibleAnswers" [value]="answer.description">
                                        {{answer.description}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <!-- Type RecordTypeSelect -->
                            <mat-form-field class="form-input select" *ngSwitchCase="columnTypesEnum.RecordTypeSelect" appearance="fill">
                                <mat-select [(ngModel)]="item[col.columnOrder]">
                                    <mat-option *ngFor="let answer of recordTypeData[col.recordTypeId]" [value]="answer">
                                        <span>{{getRecordField(answer, col.recordField)}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <!-- Type RecordTypeAutocomplete -->
                            <mat-form-field class="form-input select" *ngSwitchCase="columnTypesEnum.RecordTypeAutocomplete" appearance="fill">
                                <input [type]="text" matInput [ngModel]="getAutoCompleteValue(item, col)" readonly />
                            </mat-form-field>
                        </ng-container>

                        <div class="card-divider my-3"></div>
                    </div>
                </ng-container>
            </div>
        </mat-card-content>
        
        <mat-card-actions align="end">
            <button *ngIf="!exploreMode && item.isEdit" mat-icon-button color="primary" 
                (click)="saveRow(item)" [disabled]="cantSaveRow(item)">
                <mat-icon matTooltip="{{'THIRDPARTY.CREATE_FORM.BUTTON.SAVE' | translate}}"
                    class="">check</mat-icon>
            </button>

            <button *ngIf="!exploreMode && !item.isEdit" mat-icon-button color="primary"
                (click)="saveRow(item)">
                <mat-icon matTooltip="{{'THIRDPARTY.CREATE_FORM.BUTTON.EDIT' | translate}}">
                    edit</mat-icon>
            </button>

            <button *ngIf="!exploreMode" mat-icon-button color="primary"
                (click)="removeRow(iElement)">
                <mat-icon>close</mat-icon>
            </button>
        </mat-card-actions>
    </mat-card>
    <!-- //Records Cards-->

    <!--Totalizers Card-->
    <mat-card *ngIf="thereIsTotalizer()" class="mb-3">
        <mat-card-title>{{'THIRDPARTY.RECORD_TYPE_QUESTION.TOTALIZERS' | translate}}</mat-card-title>
        <mat-card-content>
            <div class="d-flex flex-column justify-content-start">
                <ng-container *ngFor="let col of columnsSchema">
                    <div *ngIf="col.columnTypeId != -1 && col.useVerticalTotalizer"
                        class="d-flex flex-column justify-content-start mb-3">

                        <span class="mb-2"><strong>{{ col.title }}</strong></span>
                        <span>{{ calculateTotal(col) }}</span>

                    </div>
                </ng-container>
            </div>
        </mat-card-content>
    </mat-card>
    <!-- //Totalizers Card-->
</div>
<!-- //Mobile -->

<span *ngIf="checkIfSomeRowIsEdit()">
    {{'THIRDPARTY.RECORD_TYPE_QUESTION.ROW_ISEDIT_WARN' | translate}}
</span>
<mat-error *ngIf="evaluationFormGroup.get(evaluationFormControlName).hasError('rowIncomplete')">{{'INPUT.ROW_INCOMPLETE' | translate}}</mat-error>